import { Component, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material";

@Component({
  selector: "upload-snackbar",
  template: ``,
})
export class UploadSnackBarComponent {
  private progressComponentRef: any;
  constructor(private _snackBar: MatSnackBar) {}

  openSnackBar() {
    const snackBarRef = this._snackBar.openFromComponent(
      LinearProgressComponent,
      {}
    );
    this.progressComponentRef = snackBarRef.instance;
  }

  updateProgress(percentage, streetAddress) {
    if (this.progressComponentRef) {
      this.progressComponentRef.updateData(percentage, streetAddress);
    }
  }
  dismissSnackbar() {
    if (this._snackBar) {
      this._snackBar.dismiss();
    }
  }
}

@Component({
  selector: "linear-progress",
  templateUrl: "./linear-progress.component.html",
})
export class LinearProgressComponent {
  progress: number;
  streetAddres: String;
  constructor() {
    this.progress = 0;
    this.streetAddres = "Uploading....";
  }

  updateData(percentage, streetAddress) {
    //console.log(streetAddress);
    this.progress = percentage;
    this.streetAddres = streetAddress;
  }
}
